<template>
    <div class="cc-home">
        <div class="cc-sub-container">
            <div class="bg-video">
                <video
                    src="http://nadvideo2.baidu.com/demo/banner.mp4"
                    autoplay
                    muted
                    loop
                ></video>
            </div>
            <div class="cc-main-container">
                <div class="cc-header">
                    <div class="cc-header-left">
                        <img src="../../assets/logo.png" alt="">
                    </div>
                    <div class="cc-header-right">
                        <template v-if="optName">
                            <div class="cc-header-right-user">
                                <veui-button
                                    ui="xl"
                                    class="cc-header-workspace"
                                    @click="handleJumpToWorkspace"
                                >我的工作台</veui-button>
                            </div>
                            <div class="header-line"></div>
                        </template>
                        <cc-nav-coupon v-if="optName"/>
                        <div class="help-icon">
                            <span @click="gotoHelpDoc">
                                <veui-icon ref="helpRef" name="question-circle"/>
                            </span>
                            <veui-tooltip
                                position="bottom"
                                target="helpRef"
                                ui="reverse"
                                :hide-delay="100"
                                overlay-class="help-overlay"
                            >
                                帮助文档
                            </veui-tooltip>
                        </div>
                        <feedback/>
                        <message-center v-if="optName && !hagOnlyDigital"/>
                        <avatar
                            v-if="optName"
                            class="cc-header-right-user"
                        />
                        <template v-else>
                            <div class="header-line"></div>
                            <veui-button
                                ui="xl"
                                class="cc-header-login"
                                @click="handleLogin"
                            >登录</veui-button>
                        </template>
                    </div>
                </div>
                <div class="cc-main-content">
                    <div class="cc-main-content-left">
                        <div class="main-title">
                            <p>AIGC赋能</p>
                            <p>营销创意新纪元</p>
                        </div>
                        <div class="main-desc">
                            汇聚百度全新AI技术，提供精准、创新、引人入胜的多模态广告创意内容。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <cc-content
                :is-outer-user="isOuterUser"
                @clickNav="handleClickNav"
                @goDetail="handleGoDetail"
            />
            <cc-footer/>
        </div>
    </div>
</template>

<script>
/* globals ucCommonLogin */
import {Button, Icon, Tooltip} from 'veui';
import NavContent from './components/NavContent.vue';
import LinkFooter from './components/LinkFooter.vue';
import {getRedirectUrl, getRouteQuery} from '@/common/util';
import Feedback from '@/component/Feedback';
import MessageCenter from '@/views/Message/MessageCenter';
import NavCoupon from '@/component/Coupon/NavCoupon';
import Avatar from '@/layouts/Avatar.vue';
import 'veui-theme-dls-icons/user-circle';
import 'veui-theme-dls-icons/chevron-down';

export default {
    name: 'home',
    inject: ['$toast', 'alsLog'],
    components: {
        'veui-button': Button,
        'veui-icon': Icon,
        'veui-tooltip': Tooltip,
        'cc-content': NavContent,
        'cc-footer': LinkFooter,
        Feedback,
        MessageCenter,
        'cc-nav-coupon': NavCoupon,
        Avatar
    },
    computed: {
        optName() {
            return this.$store.state.app.userInfo.accountInfo?.optName || '';
        },
        hags() {
            return this.$store.state.app.userInfo.bizHags;
        },
        avatarName() {
            return this.optName?.slice(0, 1)?.toUpperCase() || '';
        },
        hagOnlyDigital() {
            return this.hags.digital_is_passport;
        },
        isStyleV2() {
            return this.$store.state.app.userInfo.isStyleV2;
        },
        isRealStyleV2() {
            return this.$store.state.app.userInfo.isRealStyleV2;
        },
        isOuterUser() {
            return this.$store.state.app.userInfo.isOuterUser;
        }
    },
    mounted() {
        this.alsLog({
            f1: 'homePagePv',
            f2: 'show'
        });
        this.checkStyleVersion();
    },
    watch: {
        isStyleV2() {
            this.checkStyleVersion();
        }
    },
    methods: {
        // 根据是否小流量名单决定页面跳转
        checkStyleVersion() {
            const useV2 = (this.isStyleV2 && window.sessionStorage.style_click_old  !== '1')
                || (this.isRealStyleV2 && window.sessionStorage.style_click_old !== '1');
            if (useV2) {
                this.$router.push({
                    name: 'homeV2Default',
                    params: {
                        userid: this.$route.params.userid
                    }
                });
            }
        },
        // 点击快捷跳转的菜单
        handleClickNav(item) {
            this.alsLog({
                f1: 'quickButton',
                f2: 'click',
                f11: `v1_quick_${item?.title}`
            });
        },
        handleLogin() {
            this.$router.push({
                path: '/login'
            });
        },
        handleJumpToWorkspace() {
            this.alsLog({
                f1: 'workspaceButton',
                f2: 'click',
                f11: 'v1_button_我的工作台'
            });
            // 目前只有一个路由
            // passport，跳到数字人页面；或者是只显示数字人tab的权限名单; 或外部账号
            if (this.hagOnlyDigital || this.isOuterUser) {
                this.$router.push({
                    name: 'digitalVideoTemplate'
                });
                return;
            }
            this.$router.push({
                query: getRouteQuery() || {},
                name: 'aiCreateFrontPage'
            });
        },
        // 首页nav抛出的开始创作
        handleGoDetail(item) {
            if (!this.optName) {
                this.handleLogin();
                return;
            }
            this.alsLog({
                f1: 'detailButton',
                f2: 'click',
                f11: `v1_button_${item.title}`
            });
            this.$router.push({
                query: getRouteQuery() || {},
                name: item.routeName
            });
        },
        gotoHelpDoc() {
            const {protocol, host} = window.location;
            const prefix = `${protocol}//${host}`;
            const firstDoc = '信息流广告标题';
            const url = `${prefix}/helpDoc/${firstDoc}`;
            this.alsLog({
                f1: 'helpDoc',
                f2: 'click',
                f5: this.$route.name,
                f15: this.$route?.path
            });
            window.open(url, '_blank', 'noreferrer');
        }
    }
};
</script>

<style lang="less" scoped>
.cc-home {
    height: 600px;
    min-width: 1240px;
    background-image: url('./assets/bannerBg.jpg');
    background-repeat: repeat;
    background-color: linear-gradient(#D8EDFF, #FFFFFF);
}
.cc-sub-container {
    height: 600px;
    width: 100%;
    max-width: 1920px;
    padding: 0 20px;
    margin: 0 auto;
    position: relative;
    .bg-video {
        margin: 0 auto;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 50%;
        transform: translateX(-50%);
    }
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.cc-main-container {
    width: 1200px;
    margin: 0 auto;
    padding-top: 22px;
    position: relative;
    .cc-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        &-left {
            img {
                height: 24px;
            }
        }
        &-right {
            display: flex;
            align-items: center;
            gap: 16px;
        }
        &-right-user {
            display: flex;
            align-items: center;
        }
        &-login {
            color: #fff;
            background: linear-gradient(270deg, #3434F4 0.3%, #4C79FF 99.35%);
            border-radius: 38px;
            padding: 9px 25px;
            font-weight: 500;
            font-size: 16px;
            border: none;
            &.login-passport {
                border: 1px solid #FFF;
                background: rgba(229, 238, 255, 0.50);
                /deep/ span {
                    background: var(--AI-, linear-gradient(271deg, #3434F4 0.3%, #4C79FF 99.35%));
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }
        }
        &-username {
            display: flex;
            align-items: center;
            cursor: pointer;
            .icon {
                margin-right: 5px;
                vertical-align: sub;
                &.down {
                    display: inline-block;
                    transform: rotate(0);
                    transition: transform 0.4s ease;
                }
            }
            &:hover {
                .icon {
                    &.down {
                        transform: rotate(180deg);
                    }
                }
            }
        }
        &-username-text {
            max-width: 100px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            line-height: 20px;
            color: #282C33;
            margin-right: 6px;
        }
        &-workspace {
            border-radius: 38px;
            padding: 7px 16px;
            color: #3434F4;
            border: 1px solid var(--AI-, #3434F4);
            background: rgba(255, 255, 255, 0.40);
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            height: 36px;
        }
        .header-line {
            height: 18px;
            width: 1px;
            opacity: 0.3;
            background: var(----G0, #FFF);
        }
    }
    .cc-main-content {
        display: flex;
        &-left {
            margin-top: 105px;
            width: 536px;
            .main-title {
                font-style: normal;
                font-weight: 600;
                font-size: 60px;
                line-height: 75px;
                color: #000000;
            }
            .main-desc {
                font-style: normal;
                font-weight: 400;
                font-size: 24px;
                line-height: 36px;
                color: #282C33;
                margin-top: 24px;
            }
        }
    }

}

.help-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    cursor: pointer;
    &:hover {
        color: #545B66;
    }
}
.help-overlay {
    /deep/ .veui-tooltip {
        border-radius: var(--Radius-r1, 6px);
        background: var(----G9, #282C33);
        margin-top: 6px;
        padding: 0 8px;
        height: 25px;
    }
    /deep/ .veui-tooltip-content {
        margin: 0px;
        color: var(----G0, #FFF);
        display: inline-flex;
        height: 100%;
        align-items: center;
    }
    /deep/ .veui-tooltip-arrow {
        color: var(----G9, #282C33);
    }
}
</style>